import * as Sentry from '@sentry/react';
import { AxiosError } from 'axios';
import { toast } from 'sonner';

type HandleExceptionArgs = {
  // The errors in the catch block may be unknown
  error: AxiosError | Error | unknown;
  toastMessage?: string;
};

/**
 * Handles exceptions by logging them to Sentry and displaying a toast message to the user.
 * For unauthorized errors (401), shows a specific message asking the user to refresh. This may be due to the user being logged to another org in a separate tab.
 * @param error - The error object caught in the catch block
 * @param toastMessage - The message to display to the user in the toast notification
 */
export const handleException = ({ error, toastMessage }: HandleExceptionArgs) => {
  // TODO: I am not sure if we should capture the unauthorised exceptions, there may be a lot of noise
  Sentry.captureException(error);

  if (toastMessage) {
    toast.error(toastMessage);
  }
};
